import script from "./InvoiceRow.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceRow.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceRow.vue?vue&type=style&index=0&id=2ee546ee&lang=css"

const __exports__ = script;

export default __exports__